import { BATCH_UPLOAD } from "./Constants/fileCategory";
import { enableAsyncPricingApi } from "./Utils/features";

export const msalConfig = {
	auth: {
		clientId: process.env.REACT_APP_AD_CLIENT_ID,
		authority: process.env.REACT_APP_AD_AUTHORITY,
		redirectUri: process.env.REACT_APP_AD_REDIRECT_URI,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	}
};

export const loginRequest = {
	scopes: [
		"User.Read"
	]
};

export const getApiRequestByUrl = (url) => {
	if (url) {

		if (enableAsyncPricingApi && (url.indexOf('api/price') !== -1 || url.indexOf('pricing/v3') !== -1)) {
			return pricerApiV2Request;
		}

		if (url.indexOf('drg') !== -1) {
			return msDrgApiRequest;
		}

		// this will catch oce in pricing/v3/claims/process/sync from the word process, so moved the enableasyncpricingapi check above
		if (url.indexOf('oce') !== -1) {
			return oceApiRequest;
		}

		if (url.indexOf('status/batches') !== -1) {
			return statusMonitorReadApiRequest;
		}

		if (url.indexOf('status/event') !== -1) {
			return statusMonitorCreateApiRequest;
		}

		if (enableAsyncPricingApi && (url.indexOf('api/price') !== -1 || url.indexOf('pricing/v3') !== -1)) {
			return pricerApiV2Request;
		}

		if (url.indexOf('dataaccess') !== -1 || url.indexOf('batchaccess') !== -1) {
			return batchDataRequest;
		}

		if (url.indexOf('configurations') !== -1) {
			return configurationsRequest;
		}

		if (url.indexOf('generate/eob') !== -1) {
			return eobGenerateRequest;
		}

		if (url.indexOf('batches') !== -1) {
			return batchApiReadAndCreateApiRequest;
		}

		if (url.indexOf(BATCH_UPLOAD) !== -1) {
			return batchDataAccessCreateRequest;
		}
	}
	return pricerApiRequest;
};

export const batchApiReadAndCreateApiRequest = {
	scopes: [
		process.env.REACT_APP_BATCH_API_READ_SCOPE,
		process.env.REACT_APP_BATCH_API_CREATE_SCOPE
	]
}

export const pricerApiV2Request = {
	scopes: [
		process.env.REACT_APP_FUNCAPI_READ_SCOPE
	]
}

export const pricerApiRequest = {
	scopes: [
		process.env.REACT_APP_WEBAPI_READ_SCOPE
	]
};

export const msDrgApiRequest = {
	scopes: [
		process.env.REACT_APP_MSDRG_API_READ_SCOPE
	]
};

export const oceApiRequest = {
	scopes: [
		process.env.REACT_APP_OCE_API_READ_SCOPE
	]
};

export const statusMonitorReadApiRequest = {
	scopes: [
		process.env.REACT_APP_STATUS_MONITOR_API_READ_SCOPE
	]
};

export const statusMonitorCreateApiRequest = {
	scopes: [
		process.env.REACT_APP_STATUS_MONITOR_API_CREATE_SCOPE
	]
};

export const batchDataRequest = {
	scopes: [
		process.env.REACT_APP_BATCHDATAACCESS_READ_SCOPE
	]
};

export const batchDataAccessCreateRequest = {
	scopes: [
		process.env.REACT_APP_BATCHDATAACCESS_READ_SCOPE
	]
}

export const configurationsRequest = {
	scopes: [
		process.env.REACT_APP_CONFIG_API_READ_SCOPE
	]
};

export const eobGenerateRequest = {
	scopes: [
		process.env.REACT_APP_EOB_GENERATE_SCOPE
	]
};
